import { TextSizeOrSpacing } from "../../types/cms"
import { MarketingFormOnBannerContent } from "../../types/cms/competition-entry-banner"
import { Sprinkles } from "../../vanilla/sprinkles.css"

/**
 * Determines the vertical position for an element
 * @param {string} position - The position value ('top', 'middle', 'bottom')
 * @returns {string} - CSS value for the vertical position
 */
export const getPositionY = (position = '') => {
        if (position === 'middle') return 'center'
        if (position === 'bottom') return 'flex-end'
        return 'flex-start'
    }

/**
 * Determines the background size for an element
 * @param {string} size - The size value ('1/3', '2/3', '3/3')
 * @returns {string} - CSS value for the background size in grid layout
 */
export const getBackgroundSize = (size = '') => {
    if (size === '1/3') return '1 / span 1'
    if (size === '2/3') return '1 / span 2'
    return '1 / span 3'
}

/**
 * Determines the spacing for an element
 * @param {string} spacing - The spacing value ('Small', 'Medium', 'Large')
 * @returns {string} - CSS value for the spacing (gap) between elements
 */
export const getSpacing = (spacing = '') => {
    if(spacing === TextSizeOrSpacing.SMALL) return '10px'
    if(spacing === TextSizeOrSpacing.LARGE) return '30px'
    return '20px'
}

/**
 * Determines the alignment for a logo based on the provided alignment value
 * @param {string} alignment - The alignment value ('left', 'center', 'right')
 * @returns {string} - CSS value for the logo alignment
 */
export const getLogoAlignment = (alignment = '') => {
    if (alignment === 'center') return 'center'
    if (alignment === 'right') return 'flex-end'
    return 'flex-start'
}

/**
 * Determines the text alignment based on the provided position value
 * @param {string} position - The position value ('left', 'center', 'right')
 * @returns {string} - CSS value for the text alignment
 */
export const getTextAlignment = (position = '') => {
    if (position === 'left') return 'left'
    if (position === 'right') return 'right'
    return 'center'
}

/**
 * Determines the horizontal position for an element
 * @param {string} position - The position value ('left', 'center', 'right', 'stretch')
 * @param {MarketingFormOnBannerContent} marketingForm - The marketing form content
 * @returns {Sprinkles['gridColumn']} - CSS value for the horizontal position in grid layout

 */
export const getPositionX = (position = '', marketingForm: MarketingFormOnBannerContent ): Sprinkles['gridColumn'] => {

    if (position === 'center') return '2'
    
    if(position === 'right') return '3'

    if (position === 'stretch') {
        const formPositionX = getPositionX(marketingForm.formPosition, marketingForm)

        if (formPositionX === '1') {
            // span 2 columns from column 2 if the form is in column 1
            return '2 / span 2'
        } 
        
        if (formPositionX === '2') {
            // Sit in column 1 if form is in column 2
            return '1'
        }

        // Span 2 columns from column 1 if form is in column 3
        return '1 / span 2'
    }

    return '1'
}